<template>
	<v-app>
		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script>
	export default {
		name: 'App',
		watch: {
		'$route':{
			handler: (to) => {
				document.title = to.meta.title || 'Hitbel Dados'
			},
				immediate: true
			}
		}
	};
</script>